import { baseFetchToken } from './BaseSaga'
import CouponPresetActions from '../Redux/CouponPresetRedux'
import { getToken } from '../Services/GetToken'

export function * getCouponPreset (api, action) {
  yield baseFetchToken(
    api.getCouponPreset,
    action.data,
    getToken,
    CouponPresetActions.getCouponPresetSuccess,
    CouponPresetActions.getCouponPresetFailure
  )
}

export function * postCouponPreset (api, action) {
  yield baseFetchToken(
    api.postCouponPreset,
    action.data,
    getToken,
    CouponPresetActions.postCouponPresetSuccess,
    CouponPresetActions.postCouponPresetFailure
  )
}

export function * putCouponPreset (api, action) {
  yield baseFetchToken(
    api.putCouponPreset,
    action.data,
    getToken,
    CouponPresetActions.putCouponPresetSuccess,
    CouponPresetActions.putCouponPresetFailure
  )
}

export function * deleteCouponPreset (api, action) {
  yield baseFetchToken(
    api.deleteCouponPreset,
    action.data,
    getToken,
    CouponPresetActions.deleteCouponPresetSuccess,
    CouponPresetActions.deleteCouponPresetFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/CouponPresetSagas.js